import { IQuery, IQueryMediator } from 'core-ts-types';
import { CancellationReasonsDatasource } from '../datasources/cancellation_reasons_datasource';

export class CancellationReasonsQuery implements IQuery {
  private _result: any;

  constructor(QueryMediator: IQueryMediator, private ngCancellationReasonsDatasource: CancellationReasonsDatasource) {
    QueryMediator.registerQuery(this, ngCancellationReasonsDatasource);
  }

  run(): CancellationReasonsQuery {
    this._result = this.ngCancellationReasonsDatasource.read();
    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/cancellation_reasons_query.ts